import React from 'react';
import './SectionDivider.scss';

import { useSelector } from 'react-redux';

import ButtonOwnDays from '../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';
import OdChevronDownIcon from '../../../static/assets/svg/od-chevron-down-icon.svg';
import { v4 } from 'uuid';

const SectionDivider = ({
  actionHandler,
  actionTitle,
  sectionName,
  sectionNameMeta,
  marginTop,
  marginBottom,
  collapsible = false,
  isCollapsed,
  tabs,
  handleToggleCollapse,
  children,
  handleTabChange,
  activeTab,
  view = 'main',
}) => {
  const dataLocale = useSelector(state => state.locale);

  const { TOGGLE } = dataLocale;

  const mainClass = `od-section-divider--${view}`;

  return (
    <div className={`${mainClass} od-font-bold`} onClick={handleToggleCollapse}>
      <div className={`${mainClass}__header`}>
        {sectionName && !tabs && (
          <div>
            <span className="od-font-bold">{sectionName}</span>
            {sectionNameMeta && <span className="od-font-reg"> {sectionNameMeta}</span>}
          </div>
        )}

        {tabs && tabs.length > 0 && (
          <div className={`${mainClass}__header__tabs`}>
            {tabs.map(tab => {
              return (
                <div
                  key={v4()}
                  className={`${mainClass}__header__tabs__tab ${
                    activeTab &&
                    !isCollapsed &&
                    activeTab === tab.switcher &&
                    `${mainClass}__header__tabs__tab--active`
                  }`}
                  onClick={() => handleTabChange(tab.switcher)}
                >
                  {tab.name}
                </div>
              );
            })}
          </div>
        )}

        {collapsible && (
          <img
            alt={TOGGLE}
            className={`${mainClass}__collapse-toggler ${
              isCollapsed && `${mainClass}__collapse-toggler--collapsed`
            }`}
            src={OdChevronDownIcon}
          />
        )}

        {actionTitle && (
          <ButtonOwnDays
            fontClass="od-font-bold"
            fontSize="14px"
            mode="transparent-light"
            py="12px"
            width="375px"
            onClick={actionHandler}
          >
            {actionTitle}
          </ButtonOwnDays>
        )}

        {children}
      </div>
      <div className={`${mainClass}__line`} style={{ marginTop, marginBottom }} />
    </div>
  );
};

export default SectionDivider;
